import React from 'react';
import styles from '../NewYear.module.scss';
import { Button } from '@axeedge/go-teacher-components';
import { Link } from '@reach/router';
import wondeLogo from '../../../images/dashboard/wonde-logo2.png';
import PageHeader from '../../../components/PageHeader';
import {Users} from 'react-feather'


const Step0 = ({ setCurrentStep }) => {
    return (
        <>
            <PageHeader title={`Activate Wonde`} icon={Users} />
            <div className={styles.stepContainer}>
                <div className={styles.step0}>
                    <div className={styles.step0Inner}>
                        <h2>
                            Make Class Management Effortless – Switch to Wonde!
                        </h2>

                        <p className={styles.step0Paragraph}>
                            Are you about to complete the manual new year
                            rollover? Yes, it works… but it could be so much
                            quicker and easier.
                        </p>

                        <p className={styles.step0Paragraph}>
                            With Wonde integration, BoomReader automatically
                            syncs nightly, so class moves, Year 6 archiving, and
                            pupil updates all happen seamlessly — no more
                            spreadsheets, no more bulk uploads.
                        </p>

                        <p className={styles.step0Paragraph}>
                            Free yourself from admin headaches. Save time,
                            reduce errors, and get your new school year off to a
                            smooth start.
                        </p>

                        <p className={styles.step0Paragraph}>
                            Simply click on 'activate Wonde' in your
                            subscription settings today and let BoomReader do
                            the hard work for you!
                        </p>

                        <img className={styles.wondeLogo} src={wondeLogo}></img>

                        <div className={styles.AcceptDenyButtonsWondeContainer}>
                            <Link
                                to='/settings/boomreader'
                            >
                                <button className={styles.buttonTakeMeThere}>
                                    Take me there
                                </button>
                            </Link>
                            <Button onClick={() => setCurrentStep(1)}>
                                No, thank you 
                            </Button>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
};

export default Step0;
